// extracted by mini-css-extract-plugin
module.exports = {"container":"create-policy_container__23Lj3","icon":"create-policy_icon__1qSIQ"};